import Layout from '@uikit/components/Layout/Layout';
import clsx from 'clsx';
import { PressLayoutProps } from './interfaces';
import styles from './PressLayout.module.scss';

const PressLayout = ({ children, className }: PressLayoutProps) => {
  return (
    <Layout className={clsx(styles.layout, className)} variant="default">
      {children}
    </Layout>
  );
};

export default PressLayout;
